import projection from '../generated/pwn511f1.json';
import { AcceptanceManifest } from '../types';
export const pwn511f1AcceptanceManifest = projection as AcceptanceManifest;
